import { Component } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { AdministradorService } from '../../../../services/administrador.service';
import { SaldoMedicoFormatoXLS, SaldoMedicoGeneral } from '../../../../models/totales-generales.interface';
import { Paginar } from 'src/app/models/http-paginacion.interface';
@Component({
  selector: 'app-administrador-medicos-saldos-general',
  templateUrl: './administrador-medicos-saldos-general.component.html',
  styleUrls: ['./administrador-medicos-saldos-general.component.scss']
})
export class AdministradorMedicosSaldosGeneralComponent {
  currentPage: Paginar = { page: 0,  first: 0,  rows: 10, pageCount: 0 };
  totalItems: number = 10; 

  saldosMedicos: SaldoMedicoGeneral[] = [];

  constructor(private administradorService: AdministradorService){
    this.obtenerInformacion();
  }
  get totalPaginas(): number {
    return Math.ceil(this.saldosMedicos.length / this.currentPage.rows);
  }
  get paginacionSaldosMedicos(): SaldoMedicoGeneral[] {
    const startIndex = (this.currentPage.page ) * this.currentPage.rows;
    return this.saldosMedicos.slice(startIndex, startIndex + this.currentPage.rows);
  }
  obtenerInformacion(){
    this.administradorService.puntosysaldosMedicos().subscribe({
      next:(resp) => {
          this.saldosMedicos = resp;  
          this.totalItems = resp.length;
      },
      error: (err: HttpErrorResponse)=> {
        console.log(err);
      }
    })
  }
  onPageChange(event: any) {
    this.currentPage = <Paginar>event;   
  }
  exportExcel(): void {
    const EXCEL_EXTENSION = '.xlsx';
    const saldosMedicos: SaldoMedicoFormatoXLS[] = this.fullSaldosMedicos(this.saldosMedicos);     
    const titulo = [{campo: "Saldos de Medicos ", fecha: new Date().toLocaleDateString()}];
    const fileName = 'saldos-medicos';

    import('xlsx').then((XLSX)=>{
          const ws = XLSX.utils.json_to_sheet([]);
          XLSX.utils.sheet_add_json(ws, titulo, { origin:"A2", skipHeader: true });
          XLSX.utils.sheet_add_json(ws, saldosMedicos, { origin:"A4" });
          /* generate workbook and add the worksheet */
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, 'saldos-medicos');            
          /* save to file */  
          
          XLSX.writeFile(wb, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    });
  }
  fullSaldosMedicos(saldos:SaldoMedicoGeneral[]): SaldoMedicoFormatoXLS[]{
    const saldoMedicos = this.saldosMedicos.map((item)=> { return {Medico: item.medico, "Total Canje": item.total_redimir, Puntos: item.total_puntos, Saldo: item.saldo } });
    return saldoMedicos;
  }
}
